class Excel {
  static download(excelData, fileName)
  {
    const url = window.URL.createObjectURL(new Blob([excelData]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}_${new Date().toISOString()}.xlsx`);
    document.body.appendChild(link);
    link.click();
  }
}

export default Excel
